import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/store'
import { updatePreviewResponse } from '@/store/slices/preview'
import { Textarea } from '@/components/ui/textarea'

const Text: React.FC = () => {
    const dispatch = useDispatch()
    const { selectedQuestionId } = useSelector((state: any) => state.preview)
    // Get question data from Redux store
    const question = useSelector((state: RootState) =>
        state.preview.questions.find(
            (q: any) => q.questionId === selectedQuestionId
        )
    )

    const savedResponse = useSelector(
        (state: RootState) => state.preview.previewResponses[selectedQuestionId]
    )

    const [selectedOption, setSelectedOption] = useState<string | null>(
        savedResponse?.optionId || null
    )
    const [otherValue, setOtherValue] = useState<string>(
        savedResponse?.otherValue || ''
    )

    // Update local state when Redux store changes
    useEffect(() => {
        if (savedResponse) {
            setSelectedOption(savedResponse.optionId || null)
            setOtherValue(savedResponse.otherValue || '')
        } else {
            setSelectedOption(null)
            setOtherValue('')
        }
    }, [savedResponse])

    useEffect(() => {
        if (selectedOption) {
            dispatch(
                updatePreviewResponse({
                    questionId: selectedQuestionId,
                    response: {
                        optionId: selectedOption,
                        otherValue:
                            selectedOption === 'other' ? otherValue : '',
                    },
                })
            )
        }
    }, [selectedOption, otherValue, dispatch, selectedQuestionId])

    if (!question) return null

    return (
        <div className="mt-6">
            <Textarea
                placeholder={question.config.placeholder}
                value={savedResponse?.value || ''}
                rows={4}
                style={{ maxHeight: '6em', overflow: 'auto' }}
                onChange={(e) =>
                    dispatch(
                        updatePreviewResponse({
                            questionId: selectedQuestionId,
                            response: {
                                value: e.target.value,
                            },
                        })
                    )
                }
            />
        </div>
    )
}

export default Text
